<!-- eslint-disable vue/no-v-html -- sanitized with DOMPurify below -->
<template>
  <p v-if="paragraph" class="sp-finder-rich-text" part="base" v-html="sanitized"></p>
  <span v-else-if="sanitized" class="sp-finder-rich-text" part="base" v-html="sanitized"></span>
</template>

<script setup>
import DOMPurify from "dompurify";
import { computed } from "vue";

const props = defineProps({
  /**
   * CMS-authored rich text: broadcasts, scheduling messages and the no-results text.
   *
   * @type {String}
   */
  html: {
    type: String,
    default: "",
  },
  /**
   * The element the text renders in.
   *
   * @type {String}
   */
  tag: {
    type: String,
    default: "span",
    validator: (value) => ["p", "span"].includes(value),
  },
});

const ALLOWED_TAGS = ["a", "b", "br", "em", "i", "p", "span", "strong", "u", "ul", "ol", "li"];
const ALLOWED_ATTR = ["href", "target", "rel", "title"];

const sanitized = computed(() => (props.html ? DOMPurify.sanitize(props.html, { ALLOWED_TAGS, ALLOWED_ATTR }) : ""));
const paragraph = computed(() => Boolean(sanitized.value) && props.tag === "p");
</script>

<style lang="scss" scoped>
.sp-finder-rich-text :deep(a) {
  font-family: var(--sp-comp-finder-result-rich-text-link-font-family, var(--sp-sys-typescale-link-font-family));
  font-weight: var(--sp-comp-finder-result-rich-text-link-font-weight, var(--sp-sys-typescale-link-font-weight));
  color: var(--sp-comp-finder-result-rich-text-link-color, var(--sp-sys-color-link));
  text-decoration: var(--sp-comp-finder-result-rich-text-link-text-decoration, none);
  text-underline-offset: var(--sp-comp-finder-result-rich-text-link-text-underline-offset, auto);

  &:hover {
    color: var(
      --sp-comp-finder-result-rich-text-link-color-hover,
      var(--sp-comp-finder-result-rich-text-link-color, var(--sp-sys-color-link))
    );
    text-decoration: var(--sp-comp-finder-result-rich-text-link-text-decoration-hover, none);
  }
}
</style>
